import {IScanService} from '@techsee/techsee-client-infra/lib/services/ScanService';
import {IScanOptions} from './contracts';
import {SCANNERS} from './ts-scan.settings';
import Scanner from './ts-scanner';

export default class TextScanner extends Scanner {
    constructor(accountSettings: any, roomId: string, scanService: IScanService) {
        super(SCANNERS.TEXT, roomId, scanService, accountSettings.language);
    }
}
